<template>
	<div class="price">
		<el-tabs type="border-card" v-model="activeTab" @tab-click="tabHandler">
      <el-tag type="danger" style="float: left;margin-bottom: 10px">注意：按分钟计费是指从进入应用开始到退出应用这一段时间，
        切记在不使用应用时退出应用</el-tag>
			<el-tab-pane label="授权码价格" name="sn">
				<el-table :data="tableData" style="width: 100%;">
					<el-table-column v-for="(item,index) in tableColumn" :key="index"
					:prop="item.key" :label="item.value" :min-width="item.width" align="center" show-overflow-tooltip></el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="托管应用价格" name="appli">
				<el-table :data="tableData" style="width: 100%;">
					<el-table-column v-for="(item,index) in tableColumn" :key="index"
					:prop="item.key" :label="item.value" :min-width="item.width" align="center" show-overflow-tooltip></el-table-column>
				</el-table>
			</el-tab-pane>
      <el-tab-pane label="SDK授权价格" name="sdk">
        <el-table :data="tableData" style="width: 100%;">
          <el-table-column v-for="(item,index) in tableColumn" :key="index"
                           :prop="item.key" :label="item.value" :min-width="item.width" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="代理转发" name="turn">
        <el-table :data="tableData" style="width: 100%;">
          <el-table-column v-for="(item,index) in tableColumn" :key="index"
                           :prop="item.key" :label="item.value" :min-width="item.width" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
      </el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
import {Message} from "element-ui";
const columns = [{
		key: 'itemName',
		value: '名称',
		width: '280'
	},{
		key: 'chargeTypeSelf',
		value: '计费类型',
		width: '100'
	},{
		key: 'priceSelf',
		value: '单价',
		width: '180'
	},{
		key: 'priceByQuantitySelf',
		value: '按量付费',
		width: '100'
	},{
		key: 'quantityStep',
		value: '量价的加价幅度',
		width: '180'
	},{
		key: 'quantityUnit',
		value: '单位',
		width: '100'
	},{
		key: 'feeByPeriodSelf',
		value: '周期计费',
		width: '180'
	},{
		key: 'periodUnit',
		value: '周期',
		width: '100'
	},{
		key: 'note',
		value: '说明',
		width: '280'
	},
]
export default {
    data() {
			return{
				activeTab: 'sn',
				tableData: [], // 授权码价格table
				tableColumn: columns
			}
		},
		created(){
      // console.log(this.$route.query.from)
			if(this.$route.query.from === 'sn' || this.$route.query.from === undefined) {
				this.activeTab = 'sn';
				this.getList(1)
			} else if(this.$route.query.from === 'appli') {
				this.activeTab = 'appli';
        this.getList(3)
			} else if(this.$route.query.from === 'sdk') {
        this.activeTab = 'sdk';
        this.getList(2)
      }
      else if(this.$route.query.from === 'turn') {
        this.activeTab = 'turn';
        this.getList(6)
      }

		},
		methods: {
			// 获取列表
			getList(type) {
				this.getRequest('/pocPriceItem/list', {"type": type}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
							 console.log(resp.data.result,'result');
              this.tableData = resp.data.result.map(item => {
								return Object.assign(item, {
									chargeTypeSelf: item.chargeType2==='Y' ? '按需' : (item.chargeType1==='Y' ? '包年/包月' : ''), // 计费类型
									priceSelf: item.priceUnit && (item.price || item.price === 0) ? String(item.price) + item.priceUnit + '起': (!item.priceUnit && item.price? String(item.price):(item.priceUnit && !item.price?item.priceUnit:'0')) + '起',
									priceByQuantitySelf: item.priceByQuantity === 1 ? '是' : (item.priceByQuantity === 0 ? '否' : ''), // 是否按量付费
									feeByPeriodSelf: item.feeByPeriod === 1 ? '是' : (item.feeByPeriod === 0 ? '否' : ''), // 是否为周期计费
								})
							})
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
			},
			// tab切换
			tabHandler(e) {
				if(e.name == 'sn') this.getList(1);
				if(e.name == 'appli') this.getList(3);
        if(e.name == 'turn') this.getList(6);
				if(e.name == 'sdk') this.getList(2);
			}
		},
}
</script>
<style scoped>
.price{
	padding: 15px 0;
	box-sizing: border-box;
}
</style>
